
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";
import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import TableViewIcon from '@/components/icons/TableViewIcon.vue';
import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModal.vue";
import RouteNames from "@/entities/RouteNames";
import Processing from "@/components/common/Processing.vue";
import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';
import CopyLink from '@/components/icons/CopyLink.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import TooltipVariants from '@/entities/TooltipVariants';

@Component({
  components: {
    DocumentProvider,
    TableViewIcon,
    Processing,
    CopyLink,
    S3Image,
    Tooltip,
    TooltipVariants,
    ConfirmRemovingDocumentModal,
  },
})
export default class suggestedResourceTable extends Vue {
  @Prop({ type: Array, required: true }) suitableContractors: { id: string }[];
    TooltipVariants = TooltipVariants;

  contractorRates(res): string | undefined {
    const minRate = res.profile.min_rate;
    const maxRate = res.profile.max_rate;
    const rateUnit = res.profile.rate_unit;

    if (!minRate && !maxRate) {
      return "n/a";
    }

    if (!maxRate ) {
      if(rateUnit)  return `${minRate}/${rateUnit}`;
      else return `${minRate}`;
    }

    if (!minRate){
      if(rateUnit)  return `${maxRate}/${rateUnit}`;
      else return `${maxRate}`;
    }

    return `$${minRate}-${maxRate}/${rateUnit}`;
  }

  contarctorJob(res): string {
    if (res.profile.job_title && res.profile.job_title.length > 1) {
      return res.profile.job_title;
    } else {
      return "n/a";
    }
  }
  get defaultImageClasses() {
    return "text-storm-gray text-sm font-medium rounded-full border border-gray-300 bg-white h-5 w-5 mr-1";
  }
  get getAvatrClass() {
    return "chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xs justify-center text-white";
  }

async handleCopy(res) {
		try {
			await navigator.clipboard.writeText(
				`${window.location.origin}/company_database/contractors/${res.routeParams.params.id}/about`
			);
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(`Profile link copied to clipboard!`)
			);
		} catch (err) {}
	}

  contractorPageRoute(res) {

    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: res.routeParams.params.id,
      },
    };
  }

  getInitials(name) {
    const words = name.toString().split(" ");
    const initials = words.map((word) => word.charAt(0));
    const result = initials.join("");
    return result;
  }
}
